import { get } from 'lodash-es';
import { roleKindTranslations, generalRoleTranslations } from 'unihow-common';
import 'moment/locale/fi';
import 'moment/locale/sv';
import { AVAILABLE_LANGUAGES } from '../constants';
import WithLang from './WithLang';
import envConfig from '../constants/env';

import fi from './fi.translations.json';
import sv from './sv.translations.json';
import en from './en.translations.json';

export const translations = { fi, sv, en };
AVAILABLE_LANGUAGES.forEach((lang) => {
  translations[lang].generalRoles = generalRoleTranslations[lang];
  translations[lang].roleKinds = roleKindTranslations[lang];
});

export const getTranslation = (strMap, requestedLang) => {
  if (strMap) {
    return strMap[requestedLang]
      || strMap[AVAILABLE_LANGUAGES[0]]
      || AVAILABLE_LANGUAGES
        .filter((l) => strMap[l])
        .map((l) => strMap[l])
        .shift();
  }

  return null;
};

export const getTranslationWithLocale = (translationKey, locale) =>
  get(translations[locale], translationKey);

export const withLang = WithLang;
export { langType } from '../constants/types';

const getInAllLanguagesAvailable = (key, searchPattern, replaceValue) =>
  AVAILABLE_LANGUAGES.reduce((prev, curr) => {
    const value = get(translations[curr], key);
    return typeof value === 'string'
      ? {
        ...(!!prev && prev),
        [curr]: value.replace(searchPattern, replaceValue)
      }
      : prev;
  }, undefined);

export const getMessages = (messageKey, searchPattern, replaceValue) =>
  getInAllLanguagesAvailable(`MESSAGES.${messageKey}`, searchPattern, replaceValue);

export const getResearchAgreement = (agreementKey) =>
  getInAllLanguagesAvailable(`MESSAGES.researchAgreement.${agreementKey}`);

export const getLocalizedResearchAgreement = (surveyType) => {
  const petition = getResearchAgreement(`petition.${surveyType}`);
  const furtherInformation = getResearchAgreement('furtherInformation');
  const privacyNotice = getResearchAgreement('privacyNotice');

  const makeLink = (url, label) => (url ? `${label} <a href="${url}">${url}</a>` : undefined);

  return Object.entries(petition).reduce((prev, [lang, researchAgreement]) => ({
    ...prev,
    [lang]: [
      researchAgreement,
      [
        makeLink(envConfig.RESEARCH_AGREEMENT?.[surveyType]?.furtherInformation?.[lang], furtherInformation[lang]),
        makeLink(envConfig.RESEARCH_AGREEMENT?.[surveyType]?.privacyNotice?.[lang], privacyNotice[lang])
      ].filter((link) => !!link).join('<br>')
    ].join('')
  }), {});
};
